import React, { useState } from 'react';
import {
  Dialog,
} from "@/components/ui/dialog";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

export default function ConfirmableDialog(props) {
  const {
    open,
    onOpenChange,
    children,
    className,
    warningTitle = "Are you sure you want to close?",
    warningDescription = "Your information will be lost if you click Yes.",
    ...rest
  } = props;

  const [showConfirm, setShowConfirm] = useState(false);

  const handleOpenChange = (newOpen) => {
    if (!newOpen && open) {
      setShowConfirm(true);
    } else {
      onOpenChange(newOpen);
    }
  };

  const handleConfirmClose = () => {
    setShowConfirm(false);
    onOpenChange(false);
  };

  const handleCancelClose = () => {
    setShowConfirm(false);
  };

  return (
    <>
      <Dialog open={open} onOpenChange={handleOpenChange} {...rest}>
        {children}
      </Dialog>

      <AlertDialog open={showConfirm} onOpenChange={setShowConfirm}>
        <AlertDialogContent className="bg-slate-900 border-slate-700">
          <AlertDialogHeader>
            <AlertDialogTitle className="text-slate-100">{warningTitle}</AlertDialogTitle>
            <AlertDialogDescription className="text-slate-400">
              {warningDescription}
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel
              onClick={handleCancelClose}
              className="bg-slate-800 border-slate-700 text-slate-100 hover:bg-slate-700"
            >
              No, go back
            </AlertDialogCancel>
            <AlertDialogAction
              onClick={handleConfirmClose}
              className="bg-red-600 hover:bg-red-700 text-white"
            >
              Yes, close
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
}